import { createAsyncThunk } from "@reduxjs/toolkit";
import { APIList } from "config/apiList";
import { baseUrl, partnerUrl } from "config/defaultUrl";
import axios from "utils/axios";

interface createUserArgs {
  polHolderEmail: string;
  polHolderName: string;
  polHolderPhone: string;
}

interface VerifyOtpArgs extends createUserArgs {
  otp: string | number;
}

export const createUserThunk = createAsyncThunk("kyp/createUserThunk", async (payload: createUserArgs) => {
  const response = await axios.post(baseUrl + APIList.createUser, payload);
  return response.data;
});

export const getPartnerData = createAsyncThunk("kyp/getPartnerData", async (userName: string) => {
  const response = await axios.get(partnerUrl + `${APIList.getPartnerData}/${userName}`);
  return response.data;
});

export const verifyOtpThunk = createAsyncThunk("kyp/verifyOtpThunk", async (payload: VerifyOtpArgs) => {
  const response = await axios.post(baseUrl + APIList.verifyOtp, payload);
  return response.data;
});
